<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="cms/static-content/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { StaticContent } from '@/modules/cms/data/static-content/create'
	import { StaticContentService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return StaticContent;
			},

			service()
			{
				return new StaticContentService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>